import "./index.css";
import { useTranslation } from "react-i18next";
import { NotProvided } from "@/components/NotProvided";
import type { IContractingCompany } from "@/types/companies-contractors";
import type { ILender } from "@/types/companies-lenders";
import type { ICompanyChangeRequest } from "@/types/company-change-request";
import { Avatar, Column, Row, Skeleton, Text } from "@/ui-kit";
import { AddressUtils } from "@/utils/address";

type IProps = {
  request: ICompanyChangeRequest;
  currentCompany: ILender | IContractingCompany;
  newCompany: ILender | IContractingCompany | undefined;
  newCompanyLoading: boolean;
};

export const ChangeCompanyDetails = ({
  request,
  currentCompany,
  newCompany,
  newCompanyLoading,
}: IProps) => {
  const { t } = useTranslation();

  return (
    <Column gap="md" fullWidth>
      <Column gap="xs" fullWidth>
        <Text tone="muted">{t("label.changeCompany.currentCompany")}</Text>
        <Row gap="sm">
          <Avatar size="lg" src={currentCompany.companyLogo} />
          <Column fullWidth>
            <Text size="lg" weight="bold" tone="default">
              {currentCompany.name}
            </Text>
            <Text tone="muted">
              {AddressUtils.format(currentCompany.address)}
            </Text>
          </Column>
        </Row>
      </Column>

      <Column gap="xs" fullWidth>
        <Text tone="muted">{t("label.changeCompany.requestedCompany")}</Text>
        <Row gap="sm">
          {newCompanyLoading ? (
            <Skeleton width="100%" height="2.625rem" />
          ) : (
            <>
              <Avatar
                size="lg"
                src={newCompany ? newCompany.companyLogo : undefined}
                text={newCompany ? newCompany.name : request.newCompanyName}
                showDetails={false}
                loading={newCompanyLoading}
              />
              <Column fullWidth>
                <Text size="lg" weight="bold" tone="default">
                  {newCompany ? newCompany.name : request.newCompanyName}
                </Text>
                {newCompany && (
                  <Text tone="muted">
                    {AddressUtils.format(newCompany?.address)}
                  </Text>
                )}
              </Column>
            </>
          )}
        </Row>
      </Column>

      <Column gap="xs" fullWidth>
        <Text tone="muted">{t("label.comment")}</Text>
        <Text tone="default">{request?.comment || <NotProvided />}</Text>
      </Column>
    </Column>
  );
};
